import { render, staticRenderFns } from "./admin_cirugia.vue?vue&type=template&id=5ee4c0cd&"
import script from "./admin_cirugia.js?vue&type=script&lang=js&"
export * from "./admin_cirugia.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports